export const Pagination = ({ page, pages, onChange }) => {
    if (pages <= 1) return null;
  
    return (
      <div className="flex justify-center gap-2 mt-12">
        <button
          disabled={page === 1}
          onClick={() => onChange(page - 1)}
          className="px-3 py-1 border disabled:opacity-50"
        >
          Prev
        </button>
  
        {Array.from({ length: pages }).map((_, i) => (
          <button
            key={i}
            onClick={() => onChange(i + 1)}
            className={`px-3 py-1 border ${
              page === i + 1 ? "bg-black text-white" : ""
            }`}
          >
            {i + 1}
          </button>
        ))}
  
        <button
          disabled={page === pages}
          onClick={() => onChange(page + 1)}
          className="px-3 py-1 border disabled:opacity-50"
        >
          Next
        </button>
      </div>
    );
  };
  